import React from "react";
import LoginForm from '../Forms/LoginForm.jsx';
import { Redirect } from 'react-router-dom';
import { Routes } from './../Core/Constants';

export default class Login extends React.Component {
	state = {
		success: false
	}

	handleSuccessLogin = () => {
		window.gtm.onLogin('login');
		this.setState({ success: true });
	}
	render() {
		let T = window.Texts.login;
		if (this.state.success)
			return <Redirect to={Routes.SuccessLogin} />;
		return (
			<div className="page-cover">
				<div className="login-page">
					<div className="cover">
						<div className="headline">
							<h1>{T.loginTitle}</h1>
						</div>
						<div className="inner-305">
							<LoginForm onSuccess={() => this.handleSuccessLogin()} />
						</div>
					</div>
				</div>
			</div>);
	}
}
